<template>
<div class="chapter">
<div class="inner_page">
<div class="section level1" id="chapter-10-potus-2036">
<h1>Chapter 10<br/> POTUS (2036)</h1>
<p>Aeonite Commander Elva and Aeonite Commander Dorian have arrived at the Christopher C Kraft Junior Mission Control Centre at the invitation of the President of the United States. They are in human form. Dressed in dark suits, they look like FBI agents.</p>
<p>POTUS offers his hand. “Gentlemen. Welcome to Planet Earth.”</p>
<p>“Thank you. We are honoured to meet you,” says Dorian.</p>
<p>POTUS continues, “We have much to discuss. I will need to count on your discretion.”</p>
<p>“We shall keep it quiet. No one needs to know we are even here,” says Dorian.</p>
<p>POTUS nods. “Only staff with the relevant security clearances will be read into this.”</p>
<p>“Sure,” responds Dorian.</p>
<p>The President gestures to a door, and he leads them into another room. They take a seat at a large table. Dorian sends Elva out of the room. “I got this Elva. Why don’t you have a tour of the place?”</p>
<p>Dorian gestures to a soldier to remove Elva from the room. The door is closed behind them.</p>
<p>Dorian starts the conversation. “Just before we get started, I need to let you know Elva knows nothing of our previous contact. There are things I will need him for, but there will come a time when we can cut him loose. Your staff will need to tell him they know nothing. He should be referred to me.”</p>
<p>POTUS responds, “If that’s what it takes, consider it done. Just to be clear, you are providing us with cloaking technology to hide the Earth from the galaxy.”</p>
<p>“If I can have a good look at your technologies, we might do better than that. We could look at integrating Aeonite technology and maybe even add time disbursement to the mix,” suggests Dorian.</p>
<p>POTUS is puzzled. “What will that achieve?”</p>
<p>Dorian continues, “It will hide you under the cloak, but you will also be slightly out of sync with normal time and space. You will be completely invisible.”</p>
<p>“Won’t the cloaking technology make us invisible, anyway?” asks POTUS.</p>
<p>“Mostly, but some alien species may detect the cloak. If they are good guys, they should get the message. Time disbursement means they will never find you,” explains Dorian.</p>
<p>POTUS smiles. “Even better. This could be just what we need.”</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch014.vue?f0258be2